import * as React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { ValueDescription } from '../../../value-description/value-description';
import { useRootStore } from '../../../../../../providers/root-store-provider';
import { CardDashboardTradesLoading } from '../card-loading/card-dashboard-trades-loading';
import { ValueAmount } from '../../../../value/amount/value-amount';
import { ValuePercents } from '../../../../value/percents/value-precents';
import { CardTitle } from '../../../title/card-title';
import { Switch } from '../../../../form/switch/switch';
import { IconCheck } from '../../../../icons/check';
import { Tooltip } from '../../../../tooltip/tooltip';

export const CardDashboardTradesFees: React.FC = observer(() => {
    const { t } = useTranslation();
    const { overview } = useRootStore().statisticStore.overviewStore;
    const {
        portfolioStore,
        statisticStore: { overviewStore },
    } = useRootStore();

    return (
        <CardDashboardTradesLoading fields={['fees', 'feesPercentage']}>
            <div className="relative flex h-full flex-col justify-between overflow-hidden rounded-large bg-surface p-[1.6rem] shadow-strong lg:p-[2.2rem] max-md:bg-[url('/images/card-stats/fees-bg.svg')] max-md:bg-[length:auto_10rem] max-md:bg-[position:100%_100%] max-md:bg-no-repeat xl:bg-[url('/images/card-stats/fees-bg.svg')] xl:bg-[length:auto_10rem] xl:bg-[position:100%_100%] xl:bg-no-repeat">
                <CardTitle
                    title={<div className="text-[#ff697b]">{t('layout.statisticsCard.fees.title')}</div>}
                    actions={
                        <Tooltip content={t('layout.statisticsCard.fees.subtractFees')} position="top-right">
                            <Switch
                                variant="negative"
                                checked={overviewStore.calculateFees}
                                name="switchThemeState"
                                iconOff={' '}
                                iconOn={<IconCheck />}
                                onChange={() => overviewStore.setCalculateFees(!overviewStore.calculateFees)}
                            />
                        </Tooltip>
                    }
                />

                {overview && (
                    <ValueDescription
                        value={
                            <ValueAmount
                                amount={overview?.fees}
                                currency={portfolioStore.selectedPortfolio.currency?.code || ''}
                                nullValue={0}
                                mode="pure"
                                hidable
                            />
                        }
                        description={
                            <Trans
                                i18nKey={`layout.statisticsCard.fees.ofInvestedAmount`}
                                components={{
                                    strong: <strong />,
                                    value: (
                                        <ValuePercents amount={overview?.feesPercentage} nullValue={0} mode="pure" />
                                    ),
                                }}
                            />
                        }
                        padding={'none'}
                        valueColor={'negative'}
                        descriptionColor={'negative'}
                    />
                )}
            </div>
        </CardDashboardTradesLoading>
    );
});
